import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/** What the journal window is saving, so it can say so. Set by the opener. */
export type JournalKind = 'party' | 'character' | 'city-party' | 'city-character';

@Component({
    selector: 'app-player-story',
    templateUrl: './player-story.component.html',
    styleUrls: ['./player-story.component.scss'],
    standalone: false
})
export class PlayerStoryComponent implements OnInit, AfterViewInit {

  @ViewChild('titleInput') titleInput!: ElementRef;
  playerStoryForm: FormGroup

  /** Set when editing an existing journal entry. */
  updateStory: {
    title: string,
    details: string
  } = {
      title: '',
      details: ''
    }

  /** New moves: what is moving, where to, and a ready-made title. */
  kind: JournalKind = 'party';
  destination = '';
  suggestedTitle = '';
  /** When the move ends on a city: offer to go in straight away. */
  cityName = '';
  enterCity = true;

  constructor(private formBuilder: FormBuilder, private activeModal: NgbActiveModal) { }

  get isEdit(): boolean {
    return this.updateStory.title.length > 0;
  }

  get heading(): string {
    return this.isEdit ? 'Edit journal entry' : 'Journal entry';
  }

  ngOnInit(): void {
    // A title is required; the entry is optional (a quick move needs one
    // click with the suggested title).
    this.playerStoryForm = this.formBuilder.group({
      title: [this.isEdit ? this.updateStory.title : this.suggestedTitle, Validators.required],
      details: [this.updateStory.details || ''],
    })
  }

  ngAfterViewInit(): void {
    if (this.titleInput) {
      setTimeout(() => {
        const input = this.titleInput.nativeElement as HTMLInputElement;
        input.focus();
        input.select();
      }, 0);
    }
  }

  /** Ctrl/Cmd + Enter saves from anywhere; plain Enter in the entry is a new line. */
  onEntryKeydown(event: KeyboardEvent) {
    if ((event.ctrlKey || event.metaKey) && event.key === 'Enter') {
      event.preventDefault();
      this.handleSubmit();
    }
  }

  handleSubmit() {
    if (this.playerStoryForm.invalid) {
      this.playerStoryForm.markAllAsTouched();
      return;
    }
    const value = {
      title: this.playerStoryForm.value.title.trim(),
      details: (this.playerStoryForm.value.details || '').trim(),
    };
    if (this.isEdit) {
      this.activeModal.close({ updateStory: this.updateStory, value });
    } else {
      this.activeModal.close({ ...value, enterCity: !!this.cityName && this.enterCity });
    }
  }

  closeForm() {
    this.activeModal.close(false)
  }

}
